import { Store, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';

export interface BackendState {
  online: boolean;
  servicePause: boolean;
}

export function createInitialState(): BackendState {
  return {
    online: true,
    servicePause: false,
  };
}

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'backend' })
export class BackendStore extends Store<BackendState> {
  constructor() {
    super(createInitialState());
  }
}
